<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <loading v-if="vLoading" />
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />
    <b-card
      header-bg-variant="primary"
      header-text-variant="white"
      header="ثبت سفارش سریع جدید"
    >
      <div>
        <v-row>
          <v-col cols="6">
            <v-autocomplete
              @change="
                orderCodeChange();
                agentTableChanges();
                orderByCustomer();
              "
              auto-select-first
              no-data-text="نتیجه‌ای یافت نشد!"
              v-if="!busy"
              v-model="customerName"
              :items="
                showAll
                  ? customerNames
                  : customerNames.filter(
                      (x) => x.customer_priority != 'لیست سیاه'
                    )
              "
              item-text="showName"
              item-value="id"
              class="p-0"
              label="نام مشتری"
              dense
              outlined
            ></v-autocomplete>
          </v-col>
          <v-col cols="2">
            <b-btn
              variant="success"
              class="ml-0 text-white"
              :disabled="busy"
              @click="showModal()"
              >مشتری جدید</b-btn
            >
          </v-col>
          <v-col>
            <p>&nbsp;</p>
          </v-col>
          <v-col cols="3"
            ><v-checkbox
              label="نمایش مشتریان لیست سیاه"
              v-model="showAll"
              :value="true"
            ></v-checkbox
          ></v-col>
        </v-row>

        <v-row>
          <v-col>
            <p>توضیحات</p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="content"
                :editor="editor"
                :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
            <br />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-text-field
              type="text"
              label="نام فرد درخواست کننده استعلام"
              v-model="person.name"
              disabled
              filled
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              type="text"
              label="سمت فرد درخواست کننده استعلام"
              v-model="person.role"
              disabled
              filled
              dense
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              type="text"
              label="شماره نامه / نام پروژه درخواست استعلام"
              v-model="person.letter"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="6"> </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <b-form-group label="تاریخ درخواست استعلام">
              <date-picker
                placeholder="عنوان"
                v-model="person.letterDate"
                :editable="true"
              ></date-picker>
            </b-form-group>
          </v-col>
          <v-col cols="6">
            <b-form-group label="تاریخ مورد نظر برای دریافت استعلام">
              <date-picker
                v-model="ticketDate"
                placeholder="تاریخ استعلام را انتخاب کنید"
                :editable="true"
              />
            </b-form-group>
          </v-col>
        </v-row>

        <b-form-group label="بارگذاری فایل:" label-for="indexPic">
          <b-form-file
            :state="Boolean(file)"
            @input="upload(file)"
            v-model="file"
            browse-text="آپلود"
            placeholder="فایل مربوطه را آپلود کنید"
            accept="*"
          ></b-form-file>
        </b-form-group>
        <b-form-group>
          <v-col>
            <br />
            <b-progress
              v-if="myFile.showProgress"
              :value="myFile.uploadPercentage"
              :max="max"
              show-progress
              :animated="myFile.striped"
              :variant="myFile.variant"
            ></b-progress>
            <v-row>
              <br />
              <div v-if="myFile.isUploaded" color="green" class="mt-3">
                فایل با موفقیت آپلود شد.
              </div>
            </v-row>
          </v-col>
        </b-form-group>
        <b-table
          responsive
          show-empty
          :items="uploadedFiles"
          :fields="fileFields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="فایلی بارگذاری نشده است"
          striped
          small
        >
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>

          <template v-slot:cell(delete)="data">
            <div style="text-align: center; vertical-align: middle">
              <b-btn variant="danger" @click="delFile(data.index)">
                <i class="fa fa-remove" aria-hidden="true"></i>
              </b-btn>
              <!-- <b-btn variant="success" @click="aproveFile(data.item)">
                <i class="fa fa-check" aria-hidden="true"></i>
              </b-btn> -->
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>
        <b-form-group>
          <v-col>
            <b-progress
              v-if="showProgress"
              :value="uploadPercentage"
              :max="max"
              show-progress
              :animated="striped"
              :variant="variant"
            ></b-progress>
            <v-row>
              <br />
              <div v-if="isUploaded" color="green">
                فایل با موفقیت آپلود شد.
              </div>
            </v-row>
          </v-col>
        </b-form-group>
        <b-card v-if="customerName">
          <h6>
            <v-row>
              <v-col cols="8">
                <b-input-group size="md">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="جستجو"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                      variant="danger"
                      >حذف</b-button
                    >
                  </b-input-group-append>
                </b-input-group></v-col
              >
              <v-col cols="2" class="text-left">
                <vue-excel-xlsx
                  class="darkGreen-mainBtn mb-3 float-end"
                  style="width: 135px; height: 35px"
                  depressed
                  :data="customerOrders"
                  :columns="excelFields"
                  :file-name="`درخواست‌ها`"
                  :sheet-name="`درخواست‌ها`"
                  :class="
                    customerOrders.length ? 'white--text' : 'disabled-excel'
                  "
                >
                  <v-icon
                    class="me-1"
                    :class="customerOrders.length ? 'white--text' : ''"
                  >
                    mdi-file-excel-outline </v-icon
                  >خروجی اکسل
                </vue-excel-xlsx>
              </v-col>
              <v-col cols="2">
                <v-btn
                  :disabled="gettingReceipt || !customerOrders.length"
                  class="darkRed-mainBtn white--text float-end"
                  style="width: 135px; height: 35px"
                  @click="printReceipt('orders1', 'سفارش‌های مشتری')"
                  depressed
                  ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
                >
              </v-col>
            </v-row>
          </h6>
          <b-table
            responsive
            :filter="filter"
            show-empty
            :items="customerOrders"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusy1"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>

            <template v-slot:cell(progress)="data">
              <b-progress
                :value="data.item.progress"
                variant="success"
                :striped="striped"
                show-progress
                animated
              ></b-progress>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>

          <hr />
          <v-row>
            <v-col cols="8"></v-col>
            <v-col cols="2">
              <vue-excel-xlsx
                class="darkGreen-mainBtn mb-3 float-end"
                style="width: 135px; height: 35px"
                depressed
                :data="agents"
                :columns="excelFields2"
                :file-name="`رابط‌ها`"
                :sheet-name="`رابط‌ها`"
                :class="agents.length ? 'white--text' : 'disabled-excel'"
              >
                <v-icon
                  :class="agents.length ? 'white--text' : ''"
                  class="me-1"
                >
                  mdi-file-excel-outline </v-icon
                >خروجی اکسل
              </vue-excel-xlsx>
            </v-col>
            <v-col cols="2">
              <v-btn
                :disabled="gettingReceipt || !agents.length"
                class="darkRed-mainBtn white--text float-end"
                style="width: 135px; height: 35px"
                @click="printReceipt('agentsList', 'رابط‌ها')"
                depressed
                ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
              >
            </v-col>
          </v-row>
          <b-table
            responsive
            show-empty
            :items="agents"
            :fields="fields2"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusy2"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>

            <template v-slot:cell(progress)="data">
              <b-progress
                :value="data.item.progress"
                variant="success"
                :striped="striped"
                show-progress
                animated
              ></b-progress>
            </template>
            <template v-slot:cell(operation)="data">
              <b-btn variant="warning" @click="choose(data.item)">انتخاب</b-btn>
            </template>
            <!-- <template v-slot:cell(operation)="data">
              <div style="text-align:center;vertical-align:middle">
                <b-btn
                  variant="success"
                  class="mr-1"
                  @click="editPerson(data.item)"
                >ویرایش</b-btn>
                 <b-btn
                variant="danger"
                class="mr-1"
                @click="lockCustomer(data.item)"
            >قفل</b-btn>
              </div>
            </template>-->
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-btn variant="success" class="mt-3" @click="showNewAgentDialog()"
            >افزودن رابط جدید</b-btn
          >
          <br />
        </b-card>
        <hr />
        <v-row>
          <v-col cols="6">
            <v-select
              label="روش ارسال استعلام"
              :items="sendMethods"
              v-model="sendMethod"
              outlined
              dense
            />
            <v-select
              label="روش دریافت درخواست"
              :items="receivedMethods"
              v-model="receivedMethod"
              outlined
              dense
            />
          </v-col>
          <v-col cols="6">
            <v-select
              label="الگوی مورد نظر مشتری"
              :items="productsTemplates"
              v-model="productsTemplate"
              outlined
              dense
            />
            <v-select
              label="واحد اندازه‌گیری"
              :items="measurementUnits"
              v-model="measurementUnit"
              outlined
              dense
            />
          </v-col>
          <v-col cols="6">
            <v-select
              label="واحد پول مورد نظر"
              :items="currencyOptions"
              v-model="currency"
              outlined
              dense
            />
          </v-col>
          <v-col cols="6">
            <v-select
              label="نوع استعلام مورد نظر"
              :items="orderTypes"
              v-model="orderType"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <div v-if="factoryInfoCalculated">
          <p>لطفا به منظور ارسال سفارش به کارخانه، موارد زیر را پر کنید:</p>
          <b-form-group label="تاریخ و ساعت ابلاغ">
            <date-picker
              placeholder="تاریخ"
              v-model="factoryInfo.registerDate"
              :editable="true"
            ></date-picker>
            <date-picker
              placeholder="ساعت"
              v-model="factoryInfo.registerTime"
              :editable="true"
              type="time"
            ></date-picker>
          </b-form-group>
          <v-text-field
            outlined
            dense
            label="نام مشتری"
            v-model="factoryInfo.customerName"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="تعداد اقلام"
            v-model="factoryInfo.count"
            type="number"
          ></v-text-field>
          <v-select
            outlined
            dense
            label="نوع بسته بندی"
            :items="packageOptions"
            v-model="factoryInfo.package"
          ></v-select>
          <v-text-field
            outlined
            dense
            label="نوع پوشش"
            v-model="factoryInfo.coating"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="زمان تحویل"
            v-model="factoryInfo.desiredDate"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="محل تحویل"
            v-model="factoryInfo.deliveryLocation"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            v-model="factoryInfo.transportCost"
            label="هزینه حمل"
          />
          <v-text-field
            outlined
            dense
            label="نام نماینده مشتری"
            v-model="factoryInfo.customerAgentName"
          ></v-text-field>
          <v-select
            outlined
            dense
            label="بازرسی"
            :items="inspectionOptions"
            v-model="factoryInfo.inspection"
          ></v-select>
          <v-text-field
            outlined
            dense
            label="کیلویی"
            v-model="factoryInfo.weight"
            type="number"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            label="شماره تلفن"
            v-model="factoryInfo.phone"
          ></v-text-field>
          <!-- <v-textarea
            outlined
            dense
            label="سایر توضیحات"
            v-model="factoryInfo.otherDescriptions"
          ></v-textarea> -->
          <v-text-field
            outlined
            dense
            label="آدرس ارسال"
            v-model="factoryInfo.deliveryAddress"
          ></v-text-field>
          <v-text-field
            type="number"
            outlined
            dense
            :label="'مبلغ کل سفارش (' + currency + ')'"
            v-model="factoryInfo.totalPrice"
          ></v-text-field>
        </div>

        <v-btn
          v-if="!factoryInfoCalculated"
          color="primary"
          class="mt-3"
          @click="calculateFactoryInfo()"
          >نمایش فرم کارخانه</v-btn
        >

        <v-btn
          v-if="factoryInfoCalculated"
          color="primary"
          class="mt-3"
          @click="calculateFactoryInfo()"
          >بروزرسانی فرم کارخانه</v-btn
        >

        <b-btn
          v-if="factoryInfoCalculated"
          variant="success"
          class="mt-3 float-left"
          @click="newOrder()"
          :disabled="!customerName || !sendMethod"
          >ثبت</b-btn
        >
      </div>
      <!-- <div v-html="customerTerms" /> -->
      <v-dialog v-model="newCustomerDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <h4>ثبت مشتری جدید</h4>
          </v-card-title>
          <v-card-text class="mt-2 py-0">
            <v-container>
              <v-text-field
                type="text"
                label="نام مشتری"
                v-model="newCustomerName"
                dense
                outlined
              ></v-text-field>
            </v-container>
          </v-card-text>
          <v-card-actions class="p-3 mr-3">
            <v-spacer></v-spacer>
            <v-btn
              class="text-white"
              color="red"
              @click="newCustomerDialog = false"
            >
              لغو
            </v-btn>
            <v-btn color="primary" @click="addCustomer()"> ثبت </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="newAgentDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <h4>ثبت مخاطب جدید</h4>
          </v-card-title>
          <v-card-text class="py-0 px-2">
            <v-container class="mt-3">
              <v-row>
                <v-col class="pb-0">
                  <v-text-field
                    outlined
                    dense
                    label="نام رابط"
                    v-model="newAgent.newAgentName"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0">
                  <v-text-field
                    outlined
                    dense
                    dir="ltr"
                    label="نام انگلیسی رابط"
                    v-model="newAgent.newAgentNameEn"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    outlined
                    dense
                    label="سمت"
                    v-model="newAgent.newAgentRole"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    outlined
                    dense
                    label="موبایل"
                    v-model="newAgent.newMobile"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    outlined
                    dense
                    label="ایمیل"
                    v-model="newAgent.newEmail"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    outlined
                    dense
                    label="تلفن"
                    v-model="newAgent.newPhone"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    outlined
                    dense
                    label="تلفن 2"
                    v-model="newAgent.newPhone2"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    outlined
                    dense
                    label="داخلی"
                    v-model="newAgent.newInternal"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    outlined
                    dense
                    label="فکس"
                    v-model="newAgent.newFax"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    outlined
                    dense
                    label="کد پستی"
                    v-model="newAgent.newPostalCode"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-textarea
                    outlined
                    dense
                    label="آدرس"
                    rows="3"
                    v-model="newAgent.newAddress"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="p-3 mr-3">
            <v-spacer></v-spacer>
            <v-btn
              class="text-white"
              color="red"
              @click="newAgentDialog = false"
            >
              لغو
            </v-btn>
            <v-btn color="primary" @click="addAgent()"> ثبت </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </b-card>
    <v-dialog v-model="sureDelFile" max-width="600px">
      <v-card>
        <v-card-title dark>
          <h4>آیا از حذف فایل مطمئن هستید؟</h4>
        </v-card-title>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="sureDelFile = false">
            خير
          </v-btn>
          <v-btn @click="doDelFile()" color="primary"> بله </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-show="false" :id="tableType">
      <h3 style="float: right">{{ tableTitle }}</h3>
      <b-table :items="computedTableItems" :fields="computedTableFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

function sarmadNumber(x) {
  return parseFloat(x).toFixed(
    this.currencyOptions.filter((x) => x.value == this.currency)[0].precision
  );
}

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      tableType: "",
      tableTitle: "",
      printInvoice: {},
      gettingReceipt: false,
      guide: false,
      showAll: false,
      role: "",
      sarmadNumber: sarmadNumber,
      moment: moment,
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      uploadedFiles: [],
      selectedFile: {},
      sureDelFile: false,
      mediaToken: "",
      taskSubject: "",
      lastindex: 0,
      orderCode: "",
      lastOrderIndex: 0,
      customerNames: [],
      customerName: "",
      newCustomerName: "",
      customerId: 0,
      ticketDate: "",
      dueDate: "",
      content: "",
      name: "",
      filter: "",
      fileFields: [
        { key: "index", label: "#" },
        { key: "showName", label: "نام فایل" },
        { key: "delete", label: "حذف" },
      ],
      fields: [
        //{ key: "subject", label: "عنوان درخواست" },
        { key: "code", label: "کد استعلام" },
        { key: "requestId", label: "شماره درخواست" },
        { key: "registerDate", label: "تاریخ" },
        { key: "status", label: "وضعیت" },
        //{ key: "operation", label: "عملیات" },
      ],
      excelFields: [
        { field: "code", label: "کد استعلام" },
        { field: "requestId", label: "شماره درخواست" },
        { field: "registerDate", label: "تاریخ" },
        { field: "status", label: "وضعیت" },
      ],
      isBusy1: false,
      fields2: [
        { key: "operation", label: "انتخاب" },
        { key: "name", label: "نام رابط" },
        { key: "internal", label: "داخلی" },
        { key: "role", label: "سمت" },
        { key: "phone", label: "تلفن" },
        { key: "phone2", label: "تلفن 2" },
        { key: "fax", label: "فاکس" },
        { key: "mobile", label: "موبایل" },
        { key: "email", label: "ایمیل" },
        { key: "address", label: "آدرس" },
        { key: "postalCode", label: "کد پستی" },
      ],
      excelFields2: [
        { field: "name", label: "نام رابط" },
        { field: "internal", label: "داخلی" },
        { field: "role", label: "سمت" },
        { field: "phone", label: "تلفن" },
        { field: "phone2", label: "تلفن 2" },
        { field: "fax", label: "فاکس" },
        { field: "mobile", label: "موبایل" },
        { field: "email", label: "ایمیل" },
        { field: "address", label: "آدرس" },
        { field: "postalCode", label: "کد پستی" },
      ],
      printFields2: [
        { key: "name", label: "نام رابط" },
        { key: "internal", label: "داخلی" },
        { key: "role", label: "سمت" },
        { key: "phone", label: "تلفن" },
        { key: "phone2", label: "تلفن 2" },
        { key: "fax", label: "فاکس" },
        { key: "mobile", label: "موبایل" },
        { key: "email", label: "ایمیل" },
        { key: "address", label: "آدرس" },
        { key: "postalCode", label: "کد پستی" },
      ],
      isBusy2: false,
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      person: new Object({
        id: "",
        name: "",
        role: "مدیریت ",
        letter: "",
        letterDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      }),
      customerTerms: "",
      busy: false,
      productsTemplate: "pk1",
      productsTemplates: [
        { value: "pk1", text: "الگوی PK1 فارسی" },
        { value: "pk2", text: "الگوی PK2 فارسی" },
        { value: "pken", text: "الگوی PK1 انگلیسی" },
        { value: "pken2", text: "الگوی PK2 انگلیسی" },
      ],
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],
      orderTypes: [
        { value: "full", text: "مالی" },
        { value: "technical", text: "فنی" },
      ],
      orderType: "full",
      currency: "ریال",
      receivedMethod: "",
      receivedMethods: [
        { value: "email", text: "ایمیل" },
        { value: "fax", text: "فاکس" },
        { value: "whatsapp", text: "واتساپ" },
        { value: "other", text: "سایر روش‌ها (در توضیحات ذکر شود)" },
      ],
      measurementUnit: "تعداد",
      measurementUnits: [
        { value: "تعداد", text: "تعداد" },
        { value: "کیلوگرم", text: "کیلوگرم" },
        { value: "تن", text: "تن" },
      ],
      sendMethod: "",
      sendMethods: [
        { value: "packet", text: "پاکت دربسته" },
        { value: "email", text: "ایمیل" },
        { value: "fax", text: "فاکس" },
        { value: "whatsapp", text: "واتساپ" },
        { value: "other", text: "سایر روش‌ها (در توضیحات ذکر شود)" },
      ],
      allFiles: [],
      newCustomerDialog: false,
      newAgentDialog: false,
      agents: [],
      newAgent: {},
      customerOrders: [],
      orderItems: [],
      factoryInfo: {},
      factoryInfoCalculated: false,
      packageOptions: [
        {
          value: "کارتن یا پالت چوبی",
          text: "کارتن یا پالت چوبی",
        },
        {
          value: "پالت فلزی",
          text: "پالت فلزی",
        },
        {
          value: "صندوق چوبی",
          text: "صندوق چوبی",
        },
        {
          value: "سایر",
          text: "سایر",
        },
      ],
      inspectionOptions: [
        {
          value: "دارد",
          text: "دارد",
        },
        {
          value: "ندارد",
          text: "ندارد",
        },
      ],
    };
  },
  computed: {
    computedTableItems() {
      if (this.tableType == "orders1") {
        return this.customerOrders;
      }
      if (this.tableType == "agentsList") {
        return this.agents;
      }
    },
    computedTableFields() {
      if (this.tableType == "orders1") {
        return this.fields;
      }
      if (this.tableType == "agentsList") {
        return this.printFields2;
      }
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    CKEditor,
  },
  methods: {
    print(item) {
      this.gettingReceipt = true;
      Axios.post({
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt(type, title) {
      this.tableType = type;
      this.tableTitle = title;
      //printing receipt
      var myWindow = window.open("#", this.tableType, "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title></title>"
      );
      setTimeout(() => {
        myWindow.document.write("</head><body>");
        myWindow.document.write(
          document.getElementById(this.tableType).innerHTML
        );
        myWindow.document.write("</body></html>");
        myWindow.document.close();
      }, 100);
      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    orderByCustomer() {
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getByCustomer",
        { customerId: this.customerName },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy1 = false;
          if (res.status == 200) {
            this.customerOrders = res.data;
            this.TotalRows = this.customerOrders.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy1 = false;
        });
    },
    showNewAgentDialog() {
      this.newAgentDialog = true;
    },
    addAgent() {
      this.newAgentDialog = false;
      this.isBusy2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/agent/new",
        {
          customerId: this.customerName,
          name: this.newAgent.newAgentName,
          nameEn: this.newAgent.newAgentNameEn,
          internal: this.newAgent.newInternal,
          role: this.newAgent.newAgentRole,
          phone: this.newAgent.newPhone,
          phone2: this.newAgent.newPhone2,
          fax: this.newAgent.newFax,
          mobile: this.newAgent.newMobile,
          email: this.newAgent.newEmail,
          address: this.newAgent.newAddress,
          postalCode: this.newAgent.newPostalCode,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            const title = (
              <div>
                <h5>ثبت مخاطب</h5>
                <span>.مخاطب جدید با موفقیت ثبت شد </span>
              </div>
            );
            this.toast(title, "success");
            this.agentTableChanges();
            this.newAgent.newAgentName = "";
            this.newAgent.newInternal = "";
            this.newAgent.newAgentRole = "";
            this.newAgent.newPhone = "";
            this.newAgent.newPhone2 = "";
            this.newAgent.newFax = "";
            this.newAgent.newMobile = "";
            this.newAgent.newEmail = "";
            this.newAgent.newPostalCode = "";
            this.newAgent.newAddress = "";
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.Busy = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.Busy = false;
        });
    },
    orderCodeChange() {
      this.orderCode = this.customerNames.filter(
        (x) => x.id == this.customerName
      )[0].customerCode;
    },
    agentTableChanges() {
      Axios.post(
        this.baseUrl + "/ppkpms/agents/getByCustomer",
        { customerId: this.customerName },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.Busy = false;
          this.isBusy2 = false;
          if (res.status == 200) {
            this.agents = res.data;
            this.TotalRows = this.agents.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.Busy = false;
        });
    },
    customerList() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/customers/getAll",

        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.vLoading = false;
            this.customerNames = res.data;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addCustomer() {
      this.vLoading = true;
      this.newCustomerDialog = false;
      Axios.post(
        this.baseUrl + "/ppkpms/customer/new",
        { name: this.newCustomerName },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.vLoading = false;
            this.toast(res.data, "success");
            this.newCustomerName = "";
            this.customerList();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.vLoading = false;
          this.isBusy = false;
        });
    },
    newOrder() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/fastOrder",
        {
          customerId: this.customerName,
          contactId: this.person.id,
          contactRole: this.person.role,
          contactName: this.person.name,
          desiredDate: this.ticketDate,
          orderPrice: this.factoryInfo.totalPrice,
          productsTemplate: this.productsTemplate,
          orderSendMethod: this.sendMethod,
          orderReceivedMethod: this.receivedMethod,
          originalRequestId: this.person.letter,
          currency: this.currency,
          description: this.content,
          orderType: this.orderType,
          files: JSON.stringify(this.uploadedFiles),
          registerDate: this.person.letterDate,
          measurementUnit: this.measurementUnit,
          factoryCoating: this.factoryInfo.coating,
          factoryCount: this.factoryInfo.count,
          factoryCustomerAgentName: this.factoryInfo.customerAgentName,
          factoryDate:
            this.factoryInfo.registerDate + " " + this.factoryInfo.registerTime,
          factoryDeliveryAddress: this.factoryInfo.deliveryAddress,
          factoryDeliveryCost: this.factoryInfo.transportCost,
          factoryDeliveryDuration: this.factoryInfo.desiredDate,
          factoryDeliveryLocation: this.factoryInfo.deliveryLocation,
          factoryInspection: this.factoryInfo.inspection,
          factoryPackage: this.factoryInfo.package,
          factoryPhone: this.factoryInfo.phone,
          factoryWeight: this.factoryInfo.weight,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.$router.push("/" + this.role + "/dashboard");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    delFile(item) {
      this.selectedFile = item;
      this.sureDelFile = true;
    },
    doDelFile() {
      this.uploadedFiles.splice(this.selectedFile, 1);
      this.sureDelFile = false;
      this.file = [];
    },
    choose(item) {
      this.person.id = item.id;
      this.person.name = item.name;
      this.person.role = item.role;
      const title = (
        <div>
          <h5>انتخاب رابط</h5>
          <span>.اطلاعات رابط مورد نظر ثبت گردید</span>
        </div>
      );
      this.toast(title, "success");
    },
    showModal() {
      this.newCustomerDialog = true;
    },
    closeModalStatus() {
      this.$refs["modalStatus"].hide();
    },
    upload(file) {
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);

      Axios.post(this.baseUrl + "/ppkpms/uploads/private", formData, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
        onUploadProgress: ((progressEvent) => {
          this.myFile.uploadPercentage =
            Math.round((progressEvent.loaded * 100) / progressEvent.total) - 1;
        }).bind(this),
      })
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.uploadedFiles.push(d.data[0]);
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
    calculateFactoryInfo() {
      this.factoryInfoCalculated = true;
      this.factoryInfo.registerDate = moment(new Date()).format(
        "jYYYY/jMM/jDD"
      );
      this.factoryInfo.registerTime = moment(new Date()).format("HH:mm");

      // Calculate Names
      try {
        this.factoryInfo.customerName = this.customerNames.filter(
          (x) => x.id == this.customerName
        )[0].name;
      } catch (error) {
        this.factoryInfo.customerName = "---";
      }

      try {
        this.factoryInfo.customerAgentName = this.person.name;
      } catch (error) {
        this.factoryInfo.customerAgentName = "---";
      }

      // Calculate Count and Price
      this.factoryInfo.count = 0;
      this.factoryInfo.totalPrice = 0;
      // try {
      //   this.factoryInfo.count = this.orderItems.length;
      // } catch (error) {
      //   this.factoryInfo.count = 0;
      // }

      // Packaging
      this.factoryInfo.package = "کارتن یا پالت چوبی";

      // Calculate Coating
      try {
        let coatings = [...new Set(this.orderItems.map((x) => x.cover))];
        if (coatings.length == 1) this.factoryInfo.coating = coatings[0];
        else this.factoryInfo.coating = "مطابق اقلام";
      } catch (error) {
        this.factoryInfo.coating = "مطابق اقلام";
      }

      // Delivery Date
      this.factoryInfo.desiredDate = "3 هفته کاری پس از دریافت پیش‌پرداخت";

      // Delivery Location
      this.factoryInfo.deliveryLocation = "درب کارخانه پولاد پیچکار";

      // Transport Cost
      this.factoryInfo.transportCost = "به عهده خریدار";

      // Inspection
      this.factoryInfo.inspection = "دارد";
    },
  },
  mounted() {
    this.role = localStorage.getItem("role");
    this.customerList();
  },
};
</script>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.table td {
  text-align: center;
  vertical-align: middle;
}
</style>
<style scoped>
.color1 {
  background-color: #aa879d;
  color: white;
  border: 0;
}

.color2 {
  background-color: #8e424f;
  color: white;
  border: 0;
}
.color3 {
  background-color: #60617d;
  color: white;
  border: 0;
}
.color4 {
  background-color: #bd5748;
  color: white;
  border: 0;
}
.color5 {
  background-color: #428e6d;
  color: white;
  border: 0;
}
.display {
  display: inline-block;
}
</style>
